import React from 'react';
import { useHistory } from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import parse from 'html-react-parser';

export default function Alerta(props) {
    let history = useHistory();

    const { dialogProps, setDialogProps } = props;

    if (Object.keys(dialogProps).length < 1) return null;

    const { title, text, btn1, btn2, actionBtn1, actionBtn1Params } = dialogProps;

    const isConfirm = actionBtn1 !== null;

    console.log(props);

    let textOk = typeof text === 'object' ? text.toString() : text;

    const handlerBtn1 = () => {
        setDialogProps(null);
        if (isConfirm) {
            if (actionBtn1Params !== null) {
                actionBtn1(actionBtn1Params);
            } else {
                actionBtn1();
            }
        }
    };

    const handlerDefault = () => {
        if (textOk === 'Error: Network Error') {
            history.push('/perror/' + encodeURIComponent(history.location.pathname));
        }
        setDialogProps(null);
    };

    let textParse = '';

    console.log(textOk);

    try {
        textParse = parse(textOk);
    } catch (e) {
        //
    }

    return (
        <Dialog open={dialogProps !== null} onClose={() => setDialogProps(null)} aria-labelledby="responsive-dialog-title">
            <div className="dilogContent">
                {title ? <h2 id="responsive-dialog-title">{title}</h2> : null}
                <p>{textParse}</p>
                <div className="DialogActions">
                    {isConfirm ? (
                        <React.Fragment>
                            {btn1 && (
                                <button autoFocus onClick={handlerBtn1} className="btn btn-primary">
                                    {btn1}
                                </button>
                            )}
                            {btn2 && (
                                <button onClick={() => setDialogProps(null)} autoFocus className="btn btn-default">
                                    {btn2}
                                </button>
                            )}
                        </React.Fragment>
                    ) : (
                        <button onClick={handlerDefault} autoFocus className="btn btn-primary">
                            Aceptar
                        </button>
                    )}
                </div>
            </div>
        </Dialog>
    );
}
